import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
const TOURNAMENT_DRAW_POSITIONS_API =
  environment.apiUrl + "tournament-draw-position";
const TOURNAMENT_DRAW_SCORE_API = environment.apiUrl + "tournamentscore";
const TOURNAMENT_DRAW_API = environment.apiUrl + "tournamentdraw";
const ROUND_ROBIN_GROUP_VALUE_API =
  environment.apiUrl + "tournament-round-robin-group-value";
const ROUND_ROBIN_DRAW_API =
  environment.apiUrl + "tournament-round-robin-draw";
const PICKLEBALL_TOURNAMENT_DRAW_POSITIONS_API =
  environment.apiUrl + "pickletournament-draw-position";
const PICKLEBALL_TOURNAMENT_DRAW_SCORE_API = environment.apiUrl + "pickletournamentscore";
const PICKLEBALL_TOURNAMENT_DRAW_API = environment.apiUrl + "pickletournamentdraw";
const PADEL_TOURNAMENT_DRAW_POSITIONS_API =
  environment.apiUrl + "padeltournament-draw-position";
const PADEL_TOURNAMENT_DRAW_SCORE_API = environment.apiUrl + "padeltournamentscore";
const PADEL_TOURNAMENT_DRAW_API = environment.apiUrl + "padeltournamentdraw";
@Injectable({
  providedIn: "root",
})
export class TournamentDrawService {
  constructor(private http: HttpClient) {}
  addTournamentPositions(data): Observable<any> {
    return this.http.post(TOURNAMENT_DRAW_POSITIONS_API, data);
  }
  updateTournamentPositions(id, data): Observable<any> {
    return this.http.put(TOURNAMENT_DRAW_POSITIONS_API + "/" + id, data);
  }
  getTournamentsPlayerPositionList(query): Observable<any> {
    return this.http.get(TOURNAMENT_DRAW_POSITIONS_API + "?" + query);
  }
  addPickleBallTournamentPositions(data): Observable<any> {
    return this.http.post(PICKLEBALL_TOURNAMENT_DRAW_POSITIONS_API, data);
  }
  updatePickleBallTournamentPositions(id, data): Observable<any> {
    return this.http.put(PICKLEBALL_TOURNAMENT_DRAW_POSITIONS_API + "/" + id, data);
  }
  getPickleBallTournamentsPlayerPositionList(query): Observable<any> {
    return this.http.get(PICKLEBALL_TOURNAMENT_DRAW_POSITIONS_API + "?" + query);
  }
  addPadelTournamentPositions(data): Observable<any> {
    return this.http.post(PADEL_TOURNAMENT_DRAW_POSITIONS_API, data);
  }
  updatePadelTournamentPositions(id, data): Observable<any> {
    return this.http.put(PADEL_TOURNAMENT_DRAW_POSITIONS_API + "/" + id, data);
  }
  getPadelTournamentsPlayerPositionList(query): Observable<any> {
    return this.http.get(PADEL_TOURNAMENT_DRAW_POSITIONS_API + "?" + query);
  }

  addTournamentScore(data): Observable<any> {
    return this.http.post(TOURNAMENT_DRAW_SCORE_API, data);
  }

  addTournamentDraw(data): Observable<any> {
    return this.http.post(TOURNAMENT_DRAW_API, data);
  }
  updateTournamentDraw(id, data): Observable<any> {
    return this.http.put(TOURNAMENT_DRAW_API + "/" + id, data);
  }
  getTournamentResult(id, query): Observable<any> {
    return this.http.get(TOURNAMENT_DRAW_API + "/" + id + "?" + query);
  }
  getTournamentResultList(query): Observable<any> {
    return this.http.get(TOURNAMENT_DRAW_API + "?" + query);
  }
  getRoundRobinAssignedPlayers(query): Observable<any> {
    return this.http.get(ROUND_ROBIN_GROUP_VALUE_API + "/assigned-players?" + query);
  }
  assignRoundRobinPlayer(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_GROUP_VALUE_API + "/assign-players", data);
  }
  updateRoundRobinAssignedPlayer(id, data): Observable<any> {
    return this.http.put(ROUND_ROBIN_GROUP_VALUE_API + "/assigned-players/" + id, data);
  }
  getRoundRobinDrawList(query): Observable<any> {
    return this.http.get(ROUND_ROBIN_DRAW_API + "?" + query);
  }
  generateRoundRobinDraw(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API + "/generate", data);
  }
  regenerateRoundRobinDraw(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API + "/regenerate", data);
  }
  generateRoundRobinNextRound(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API + "/generate-next-round", data);
  }
  regenerateRoundRobinNextRound(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API + "/generate-next-round", data);
  }
  resetRoundRobinNextRound(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API + "/reset-next-round", data);
  }
  addRoundRobinDraw(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API, data);
  }
  updateRoundRobinDraw(id, data): Observable<any> {
    return this.http.put(ROUND_ROBIN_DRAW_API + "/" + id, data);
  }
  updateRoundRobinMatchTimes(data): Observable<any> {
    return this.http.put(ROUND_ROBIN_DRAW_API + "/match-times", data);
  }
  saveRoundRobinResult(id, data): Observable<any> {
    return this.http.put(ROUND_ROBIN_DRAW_API + "/" + id + "/result", data);
  }
  discardRoundRobinResult(id): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API + "/" + id + "/discard-result", {});
  }
  resetRoundRobinDraw(data): Observable<any> {
    return this.http.post(ROUND_ROBIN_DRAW_API + "/reset", data);
  }
  addPickleBallTournamentDraw(data): Observable<any> {
    return this.http.post(PICKLEBALL_TOURNAMENT_DRAW_API, data);
  }
  updatePickleBallTournamentDraw(id, data): Observable<any> {
    return this.http.put(PICKLEBALL_TOURNAMENT_DRAW_API + "/" + id, data);
  }
  getPickleBallTournamentResult(id, query): Observable<any> {
    return this.http.get(PICKLEBALL_TOURNAMENT_DRAW_API + "/" + id + "?" + query);
  }
  getPickleBallTournamentResultList(query): Observable<any> {
    return this.http.get(PICKLEBALL_TOURNAMENT_DRAW_API + "?" + query);
  }
  addPadelTournamentDraw(data): Observable<any> {
    return this.http.post(PADEL_TOURNAMENT_DRAW_API, data);
  }
  updatePadelTournamentDraw(id, data): Observable<any> {
    return this.http.put(PADEL_TOURNAMENT_DRAW_API + "/" + id, data);
  }
  getPadelTournamentResult(id, query): Observable<any> {
    return this.http.get(PADEL_TOURNAMENT_DRAW_API + "/" + id + "?" + query);
  }
  getPadelTournamentResultList(query): Observable<any> {
    return this.http.get(PADEL_TOURNAMENT_DRAW_API + "?" + query);
  }

  getTournamentScore(query): Observable<any> {
    return this.http.get(TOURNAMENT_DRAW_SCORE_API + "?" + query);
  }

  resetTournamentDraw(query:string) {
    return this.http.get(TOURNAMENT_DRAW_SCORE_API + '/v1/reset' + query);
  }    
  
  resetandseedTournamentDraw(query:string) {
    return this.http.get(TOURNAMENT_DRAW_SCORE_API + '/v1/seedDraw' + query);
  }
  resetPickleBallTournamentDraw(query:string) {
    return this.http.get(PICKLEBALL_TOURNAMENT_DRAW_SCORE_API + '/v1/reset' + query);
  }
  resetPadelTournamentDraw(query:string) {
    return this.http.get(PADEL_TOURNAMENT_DRAW_SCORE_API + '/v1/reset' + query);
  }
}
